import flatpickr from "flatpickr";
import dayjs from 'dayjs';
import { getSettings } from "./components/functions";
import { block, unblock } from './components/block';

class Frontend {
	constructor() {
		const input = document.querySelector('.hpy-events-calendar-widget-input');
		if (!input) {
			return;
		}
		this.stopChange = false;
		this.currentDate = null;
		this.settings = getSettings();

		this.elements = {
			all: document.querySelector('.hpy-events-calendar-widget-all'),
			widget: document.querySelector('.widget_hpy-events-calendar-widget'),
			clear: document.querySelector('.hpy-events-calendar-widget-clear'),
		};

		const eventDates = this.getEventDates();

		if (eventDates.length) {
			const defaultDate = false !== hpyEvents.current && '' !== hpyEvents.current ? hpyEvents.current : null;
			this.calendar = flatpickr(input, {
				defaultDate: defaultDate,
				minDate: "today",
				inline: true,
				dateFormat: 'Y-m-d',
				enable: eventDates,
				onMonthChange: (selectedDates, dateStr, instance) => this.updateAllLink(instance),
				onYearChange: (selectedDates, dateStr, instance) => this.updateAllLink(instance),
				onChange: (dObj, dStr, fp) => {
					if (!this.stopChange) {
						this.selectDate(fp.selectedDates[0]);
					}
				},
				onReady: (selectedDates, dateStr, instance) => {
					if (!defaultDate && hpyEvents?.events?.length) {
						instance.jumpToDate(hpyEvents.events[0].select_date);
						this.updateAllLink(instance);
					}
				}
			});

			if ((false !== hpyEvents.current && '' !== hpyEvents.current) || 'month' === hpyEvents.type) {
				this.showClear();
			}

			this.elements.all.addEventListener('click', this.getEventsByMonth.bind(this));
			this.elements.clear.addEventListener('click', this.clearEvents.bind(this));
		} else {
			document.querySelector('.hpy-events-calendar-wrap').style.display = 'none';
			document.querySelector('.hpy-events-calendar-no-events').style.display = 'block';
		}
	}

	selectDate(date) {
		if (dayjs(this.currentDate).isSame(dayjs(date))) {
			return;
		}

		this.currentDate = date;

		block(this.elements.widget);

		jQuery.ajax({
			url: hpyEvents.rest.date,
			method: 'GET',
			dataType: 'json',
			data: {
				date: dayjs(date).format(this.settings.format),
				url: document.location.href,
				taxonomy: this.elements.all.dataset.taxonomy,
				...hpyEvents.additionalParams
			},
			success: response => {
				if (hpyEvents?.updateHistory) {
					const url = new URL(document.location.href);
					url.searchParams.set("filter_type", "date");
					url.searchParams.set("filter_date", dayjs(date).format(this.settings.format));
					url.searchParams.set("product-page", 1);
					window.history.pushState({ event_page: 1, event_type: "date" }, "", url);
				}

				this.showClear();
				jQuery(document.body).trigger('hpy_events_events_added', [response]);
			},
			complete: () => {
				unblock(this.elements.widget);
			}
		});
	}

	showClear() {
		this.elements.clear.style.display = 'inline-flex';
	}

	getEventsByMonth(e) {
		e.preventDefault();
		const date = {
			month: this.calendar.currentMonth,
			year: this.calendar.currentYear
		};
		this.stopChange = true;
		this.currentDate = null;
		this.calendar.clear();
		this.calendar.jumpToDate(dayjs(`${date.year}-${date.month + 1}-1`, "YYYY-M-D").format(this.settings.format, true));
		this.stopChange = false;

		block(this.elements.widget);

		jQuery.ajax({
			url: hpyEvents.rest.month,
			method: 'GET',
			dataType: 'json',
			data: {
				date: dayjs(`${date.year}-${date.month + 1}-1`, "YYYY-M-D").format(this.settings.format),
				url: document.location.href,
				taxonomy: this.elements.all.dataset.taxonomy,
				...hpyEvents.additionalParams
			},
			success: response => {
				if (hpyEvents?.updateHistory) {
					const url = new URL(document.location.href);
					url.searchParams.set("filter_type", "month");
					url.searchParams.set("filter_date", dayjs(`${date.year}-${date.month + 1}-1`, "YYYY-M-D").format(this.settings.format));
					url.searchParams.set("product-page", 1);
					window.history.pushState({ page: 1 }, "", url);
				}

				this.showClear();
				jQuery(document.body).trigger('hpy_events_events_added', [response]);
			},
			complete: () => {
				unblock(this.elements.widget);
			}
		});
	}

	getEventDates() {
		if (!hpyEvents || !hpyEvents.events) {
			return [];
		}

		let events = [];
		hpyEvents.events.forEach(event => {
			events.push(dayjs(event.select_date).format(this.settings.format));
		});

		return [...new Set(events)]; // returns an array of unique values
	}

	clearEvents(e) {
		e.preventDefault();

		let url = new URL(window.location);
		url.searchParams.delete('filter_type');
		url.searchParams.delete('filter_date');
		url.searchParams.delete('product-page');

		window.location = url.toString();
	}

	updateAllLink(instance) {
		if (instance?.currentYear && instance?.currentMonth >= 0) {
			this.elements.all.querySelector('span').textContent = dayjs(`${instance.currentYear}-${instance.currentMonth + 1}-1`, "YYYY-M-D").format('MMMM YYYY');
		} else {
			this.elements.all.querySelector('span').textContent = '';
		}

	}
}

window.eventsFrontend = new Frontend();